import * as actionTypes from 'constants/ActionTypes';

const initState = {
        loading: false,
        page: 1,
        next: 2,
        previous: 1,
        limit: 100,
        sortField: 'addedAt',
        sortValue: -1,
        filters: {
            search: '',
        },
    data: [],
};

const senderList = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.GET_SEND_EMAIL_LIST.REQUEST:
            return {
                ...state,
                ...action.pagination,
                loading: false,
            };
        case actionTypes.GET_SEND_EMAIL_LIST.SUCCESS: {
            return {
                ...state,
                ...action.data,
                loading: true,
            };
        }
        case actionTypes.GET_SEND_EMAIL_LIST.FAILURE:
            return {
                ...state,
                ...action.data,
                loading: true,
            };

        default:
            return state;
    }
};

export default senderList;



// WEBPACK FOOTER //
// ./app/reducers/sender/senderList.js